import { graphql } from 'react-relay';

export const refetchProfileCollectionTabQuery = graphql`
    query refetchProfileCollectionTabQuery(
        $username: String = ""
        $walletAddress: String = ""
        $collectionFirst: Int = 20
        $collectionCursor: String
        $liveAuctionsFirst: Int = 20
        $liveAuctionsCursor: String
        $fetchDrafts: Boolean = false
        $userId: String!
        $fetchUser: Boolean!
    ) {
        viewer {
            ...collectorTabConfig_viewer @relay(mask: false)
            ...NftProfileSectionCollection_viewer
            ...NftProfileSectionAuctions_viewer
        }
    }
`;
